export function getCookie(cName, regExp) {
  var name = cName + '=';
  var cA = '';
  var cI;
  var cookie;
  var cValue;
  var rValue = null;

  try {
    cA = document.cookie.split(';');
  } catch (ignore) {
    //
  }

  for (cI = 0; cI < cA.length; cI = cI + 1) {
    cookie = cA[cI];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.search(name) === 0) {
      cValue = cookie.substring(name.length, cookie.length);
      if (regExp) {
        rValue = cValue.match(regExp);
      } else {
        rValue = cValue;
      }
      break;
    }
  }
  return rValue;
}
